<template lang="pug">
.RssListItem(@click="$emit('select', index)")
  p.RssListItem__title {{ title }}
  p.RssListItem__sub {{ sub }}
</template>
<script>
export default {
  name: 'RssList',
  props: {
    index: {
      type: Number,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    sub: {
      type: String,
      default: '',
    },
  },
};
</script>
<style lang="sass">
.RssListItem
  +pointer
  box-sizing: border-box
  border-radius: 5px
  margin-right: 2rem
  margin-bottom: .5rem
  transition: all .5s
  padding: .5rem 1rem
  &:hover
    background-color: fade-out($secondary, .9)
    transition: all .5s
    .RssListItem__title
      color: lighten($text, 30%)
      transform: translateX(1%)
      transition: all .5s
  &__title
    +title($size: $l)
    padding: .4rem 0
    transition: all .5s
  &__sub
    +sub($size: $m)
</style>
